require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-wins-four-statewide-credit-union-awards.json") })
        }
      }, "path---es-articles-financial-center-wins-four-statewide-credit-union-awards");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-wins-four-statewide-credit-union-awards!./.cache/json/es-articles-financial-center-wins-four-statewide-credit-union-awards.json
// module id = 2192
// module chunks = 231608221292675